import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change. Suppressed on language switch (same path except lang prefix).
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const prevPath = prev.current;
    prev.current = pathname;

    const stripLang = (p) => {
      const parts = p.split("/").filter(Boolean);
      if (parts.length && (parts[0] === "ar" || parts[0] === "en")) parts.shift();
      return "/" + parts.join("/");
    };

    if (stripLang(prevPath) === stripLang(pathname)) {
      return; // language switch, keep position
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return null;
}
